import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const recognizeRunFilters = z.object({
  excludedSources: z.array(z.nativeEnum(Provider)),
});

export type RecognizeRunFilters = z.infer<typeof recognizeRunFilters>;

export function shouldRunRecognize(
  provider: Provider,
  filters: RecognizeRunFilters,
): boolean {
  return !filters.excludedSources.includes(provider);
}
